import { defineComponent as _defineComponent } from 'vue'
import ChannelsList from './ChannelsList.vue'
import NewChatDialog from './NewChatDialog.vue'
import ChatWindowPanel from '../common/chat/ChatWindowPanel.vue'
import { Timestamp } from 'firebase/firestore'
import { getHostName, parseGroupId } from '@/utils/chat'
import { computed, getCurrentInstance, onMounted, ref } from 'vue'
import { useGetters, useActions } from 'vuex-composition-helpers'
import { useChatStore } from '../common/chat/useChatData'
import { Channel } from '../common/chat/models'
import { useCurrentUser } from '@/common/useCurrentUser'

type GroupType = 'DM' | 'Unit'


export default /*#__PURE__*/_defineComponent({
  __name: 'ChannelsNotificationHub',
  setup(__props) {

const store = useChatStore()
const user = useCurrentUser()

const { getVisibleUsers: usersArray } = useGetters('users', ['getVisibleUsers'])

const { fetchAllUsers } = useActions('users', ['fetchAllUsers'])
const { fetchUnitNumbers } = useActions('unitNumbers', ['fetchUnitNumbers'])

const selectedChannelId = ref<string>()
const chatTitle = ref<string>()
const newGroupType = ref<GroupType>()

const chatGroupArray = computed(() => {
  if (newGroupType.value === 'DM') {
    return usersArray.value
  }

  return []
})

const creatingDMGroup = computed(() => {
  return newGroupType.value === 'DM'
})

const channelClicked = ({ documentId, group, unsubscribed }) => {
  if (unsubscribed) {
    createGroupForUnsubscribedChannel(parseGroupId(documentId).id)
  }
  chatTitle.value = group
  selectedChannelId.value = documentId
}

const onCloseChat = () => {
  selectedChannelId.value = undefined
  chatTitle.value = ''
}

const constructChatInfo = () => {
  const userSid = user.value.userSid

  return {
    participants: [userSid],
    recent: null,
    public: false,
    version: 1,
    subdomain: getHostName(),
    read: {
      [userSid]: Timestamp.now(),
    },
  } as Channel
}

const createGroupForUnsubscribedChannel = (unitId) => {
  const group = constructChatInfo()
  group.public = true

  store.createNewChatGroup(group, unitId)
}

const createGroup = ({ selected }) => {
  const group = constructChatInfo()

  if (newGroupType.value === 'DM') {
    group.participants = [...group.participants, ...selected.map((s) => s.id)]

    return store.createNewChatGroup(group)
  } else {
    return false
  }
}

const createDM = () => {
  newGroupType.value = 'DM'
}

const closeCreateChatDialog = () => {
  newGroupType.value = undefined
}

onMounted(() => {
  fetchAllUsers()
  fetchUnitNumbers()
})

return { __sfc: true,store, user, usersArray, fetchAllUsers, fetchUnitNumbers, selectedChannelId, chatTitle, newGroupType, chatGroupArray, creatingDMGroup, channelClicked, onCloseChat, constructChatInfo, createGroupForUnsubscribedChannel, createGroup, createDM, closeCreateChatDialog, ChannelsList, NewChatDialog, ChatWindowPanel }
}

})